import { render } from "./DesignTemplates.vue?vue&type=template&id=4f9c8514&scoped=true"
import script from "./DesignTemplates.vue?vue&type=script&lang=js"
export * from "./DesignTemplates.vue?vue&type=script&lang=js"

import "./DesignTemplates.vue?vue&type=style&index=0&id=4f9c8514&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9c8514"]])

export default __exports__